import React from "react";
import HeroSection from "../components/HeroSection";
import { Helmet } from "react-helmet-async";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import {
  Code2,
  Globe,
  Bug,
  Layers,
  TrendingUp,
  ShieldCheck,
  TestTube,
  Home,
} from "lucide-react";

import PerformaceData from "../components/page-components/about/PerformaceData";
import AboutTimeline from "../components/page-components/about/AboutTimeline";
import ProjectStructure from "../components/page-components/about/ProjectStruture";
import Topcompanies from "../components/page-components/about/Topcompanies";
import AboutValues from "../components/page-components/about/AboutValue";
import AboutDetailed from "../components/page-components/about/AboutDeatiled";

export default function About() {
  return (
    <>
      <Helmet>
        <title>
          About Web X Secure | Web Development, Digital Marketing Company
        </title>

        <meta
          name="description"
          content="Learn about Web X Secure, a leading web development, SEO, digital marketing and cybersecurity company helping businesses grow with innovative technology solutions."
        />

        <meta
          name="keywords"
          content="Web X Secure, Web Development Company, Digital Marketing Company, SEO Company, Cyber Security Company, Website Development Services, Software Development Company"
        />

        <meta name="robots" content="index, follow" />

        <meta name="author" content="Web X Secure" />

        <link rel="canonical" href="https://webxsecure.in/about" />

        {/* Open Graph */}
        <meta
          property="og:title"
          content="About Web X Secure | Web Development, Digital Marketing & Cyber Security Company"
        />

        <meta
          property="og:description"
          content="Learn about Web X Secure, a trusted technology company delivering web development, SEO, digital marketing and cybersecurity solutions."
        />

        <meta property="og:image" content="https://webxsecure.in/logo.png" />

        <meta property="og:url" content="https://webxsecure.in/about" />

        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Web X Secure" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />

        <meta
          name="twitter:title"
          content="About Web X Secure | Web Development, Digital Marketing & Cyber Security Company"
        />

        <meta
          name="twitter:description"
          content="Learn about Web X Secure, a trusted technology company delivering web development, SEO, digital marketing and cybersecurity solutions."
        />

        <meta name="twitter:image" content="https://webxsecure.in/logo.png" />

        {/* Organization Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "Web X Secure",
            url: "https://webxsecure.in",
            logo: "https://webxsecure.in/logo.png",
            description:
              "Web development, SEO, digital marketing, cybersecurity and software development company.",

            foundingDate: "2022",

            founder: {
              "@type": "Person",
              name: "Rohit Bhardwaj",
            },

            contactPoint: {
              "@type": "ContactPoint",
              contactType: "customer support",
              areaServed: "IN",
              availableLanguage: ["English", "Hindi"],
            },

            sameAs: [
              "https://www.linkedin.com/company/webxsecure",
              "https://www.instagram.com/webxsecure",
            ],
          })}
        </script>

        {/* Website Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebSite",
            name: "Web X Secure",
            url: "https://webxsecure.in",
          })}
        </script>

        {/* About Page Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "AboutPage",
            name: "About Web X Secure",
            url: "https://webxsecure.in/about",
            description:
              "Learn about Web X Secure, our mission, vision, services and technology expertise.",
          })}
        </script>

        {/* Breadcrumb Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: [
              {
                "@type": "ListItem",
                position: 1,
                name: "Home",
                item: "https://webxsecure.in",
              },
              {
                "@type": "ListItem",
                position: 2,
                name: "About Us",
                item: "https://webxsecure.in/about",
              },
            ],
          })}
        </script>
      </Helmet>

      <HeroSection
        subtitle="About Web X Secure"
        title="Leading Web Development & Digital Marketing Company"
        description="Web X Secure helps startups, businesses and enterprises grow through website development, web applications, SEO, digital marketing, cybersecurity and business automation solutions."
      />
      <AboutDetailed />
      <AboutValues />

      <ProjectStructure />

      <Topcompanies />
      <PerformaceData />

      <AboutTimeline />
    </>
  );
}
